import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ProgressComponent } from './components/progress/progress.component';
import { NgProgressService } from './service/progress.service';
import { NgProgressCustomBrowserXhr } from './service/browser-xhr.provider';


export class NgProgressModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  providers: [
    NgProgressService,
    NgProgressCustomBrowserXhr
  ],
  declarations: [
    ProgressComponent,
    ProgressBarComponent
  ],
  exports: [
    ProgressComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

export {
  NgProgressService,
  NgProgressCustomBrowserXhr,
  ProgressComponent
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
